import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from '../assets/styles/components/CheckoutItem'
import cx from 'classnames'
import { Flex, Badge } from 'antd-mobile'
import lang from 'lodash/lang'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import StepperContainer from '../containers/components/Stepper'
import collection from 'lodash/collection'
import helpers from 'helpers'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import DialogComponent from './../containers/hoc/Dialog'
import * as _ from 'lodash'
import OrderSummary from './../components/OrderSummary'
import { Merchant } from 'models/merchant'

class CheckoutItemComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      remarkItem: null,
      isSetItem: false,
      shouldShowRemarkDialog: false,
      shouldShowRemarkDialogIndex: -1,
      shouldShowPerItemRemarkDialog: false,
      isOpenModal: false,
      shouldShowRemarkOptions: [],
      shouldShowRemarkRemarks: [],
    }
  }

  renderCheckoutOrder = (orders, date) => {
    const {
      intl,
      classes,
      history,
      user,
      merchant,
      isHistory,
      hideRemarkField,
      bottomEle, // from TakeawayOrderDetailList
    } = this.props

    const isWaiter = merchant && user && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0
    const path = history.location.pathname
    const isCheckout = path === '/basket/checkout'

    const itemOfDishStyle = cx(classes['item-dish'], isHistory ? classes['item-dish-history-wrap'] : classes['item-dish-wrap'])
    const bgShapeCheckoutStyle = cx(classes['bg-shape'], classes['bg-shape-checkout'])

    const item = orders.map((order, index) => {
      const _item = isHistory ? order.items : order
      const _createdAt = isHistory ? order.createdAt : ''
      const _originalTotal = isHistory ? order.originalTotal : ''
      const _total = isHistory ? order.total : ''
      const _discount = isHistory ? order.discount : ''
      const _discountTotal = isHistory ? order.discountTotal : ''
      const _surcharge = isHistory ? order.surcharge : ''
      const _surchargeTotal = isHistory ? order.surchargeTotal : ''
      const _serial = isHistory ? order.serial : ''
      const _status = isHistory ? order.status : ''
      const _paymentKey = isHistory ? order.payment : '' // order.payment is the key of payment
      const _takeawayStatus = isHistory ? order.takeawayStatus : ''
      const _code = isHistory ? order.code : ''
      const _orderId = isHistory ? order.id : ''
      const _orderIdx = isHistory ? undefined : index

      return (
        <li
          key={index}
          className={itemOfDishStyle}
        >
          {!isHistory && <div className={bgShapeCheckoutStyle} />}
          {
            this.renderOrder(
              _item,
              _createdAt,
              order.table,
              _originalTotal,
              _discount,
              _discountTotal,
              _surcharge,
              _surchargeTotal,
              _total,
              _serial,
              _status,
              _paymentKey,
              _takeawayStatus,
              _code,
              _orderId,
              _orderIdx,
            )
          }
        </li>
      )
    })

    let remark
    // if (!isHistory && orders.length) {
    //   const _remarkText = intl.formatMessage({ id: 'checkout.remark' })

    //   if (!hideRemarkField) {
    //     remark = (
    //       <li
    //         key='remark'
    //         className={itemOfDishStyle}
    //       >
    //         <div className='sub-list'>
    //           <textarea placeholder={_remarkText} value={orders.remark} onChange={this.setRemark} />
    //         </div>
    //       </li>
    //     )
    //   }
    // }

    const bottomEleDiv = (
      <div className={itemOfDishStyle}>
        <div style={{ paddingBottom: '20px' }}>
          {bottomEle}
        </div>
      </div>
    )

    return (
      <ul style={{ paddingInlineStart: '0px' }}>
        {remark}
        {item}
        {bottomEle && bottomEleDiv}
        {isWaiter && isCheckout &&
          <li className={itemOfDishStyle}>
            <OrderSummary orders={orders} />
          </li>}
      </ul>
    )
  }

  // 套餐中 data 是 order.items 的 item object
  // 單點時 data 是 order object
  onRemarkBtnClick = (data, orderIndex, isSetItem = false) => {
    this.setState({
      remarkItem: data,
      isSetItem: isSetItem,
      shouldShowRemarkDialog: orderIndex,
      shouldShowRemarkOptions: data.options,
      shouldShowRemarkRemarks: data.remarks,
      shouldShowPerItemRemarkDialog: true,
      shouldShowRemarkDialogIndex: 0,
    })
  }

  renderOrder = (order, date, table, originalTotal, discount, discountTotal, surcharge, surchargeTotal, total, serial, status, paymentKey, takeawayStatus, code, orderId, orderIndex) => {
    const {
      intl,
      classes,
      history,
      merchant,
      isHistory,
      // isTakeaway,
      isSwitchOnEditMode,
      updatePerItemRemark,
      selectedRemarkItems,
    } = this.props

    const path = history.location.pathname
    const isCheckout = path === '/basket/checkout'
    const isTakeawaySummary = path === '/basket/takeaway_summary'

    const _totalChooseFrontText = intl.formatMessage({ id: 'checkout.total_choose_front' })
    const _totalChooseBackText = _.get(merchant, 'setting.hotelMode')
      ? intl.formatMessage({ id: 'checkout.total_choose_back2' })
      : intl.formatMessage({ id: 'checkout.total_choose_back' })
    const _undeterminedPrice = intl.formatMessage({ id: 'summary.undetermined.price' })
    const checkoutItemRemarkText = intl.formatMessage({ id: 'checkout.item.remark' })
    const hideRemarkMerchant = [
      '48f66a19-5a37-4be1-b214-dfaf4467bb9b',
      '5fa30907-a524-446e-9133-9058b1d05db3',
      'fa817536-812e-4bd1-99f1-caf9b621694e',
      'a5aaadea-e0f0-427c-86d3-86bd0d09c090',
      '51f6c478-7746-4373-96f9-d2eae91b97b8',
      'dbcebe9a-8ed9-4626-80bf-6d2613d1b1bb',
    ]

    const itemOfDishStyle = cx(classes['item-dish'], isHistory ? classes['item-dish-history'] : '')
    const itemWrapStyle = cx(classes['item-wrap'])
    const totalOfQtyStyle = cx(classes['total-qty'])
    const nameOfDishStyle = cx(classes['name-dish'])
    const totalOfPriceStyle = cx(classes['total-price'])
    const totalOfPricePrefixStyle = cx(classes['total-price-prefix'])
    const totalOfPriceTextStyle = cx(classes['total-price-text'])
    const bgShapeHistoryStyle = cx(classes['bg-shape'], classes['bg-shape-history'])
    const hiddenStyle = cx(classes.hidden)
    const remarkButtonStyle = cx(classes['remark-button'])
    const remarkTextStyle = cx(classes['remark-text'])
    const remarkBtnAndItemEditContainerStyle = cx(classes['remarkBtn-and-itemEdit-container'])

    // Checkout Page
    let itemOptionsTotalPrice = 0
    let itemEdit = ''
    let perItemRemarkDialog
    let perItemSelectedRemarkItems
    let selectedRemarkItemsContent = []

    if (isCheckout || isTakeawaySummary) {
      perItemSelectedRemarkItems = selectedRemarkItems[orderIndex]
    }

    if (perItemSelectedRemarkItems) {
      perItemSelectedRemarkItems.forEach((tmp, index) => {
        // > perItemSelectedRemarkItems === order[orderIndex].remarks(array)
        // > 如果單一品項點超過一份，目前所有的 remark 都放在第一項內 (remarks[0])，而其他的 remark 會是 []。
        // > 若為 remark === [] (tmp.length === 0) 則不 push remark text 的 div。
        if (tmp.length === 0) return
        const remarksForItem = tmp.reduce((result, ele, index) => {
          if (index !== 0) {
            return result + ', ' + ele
          } else {
            return ele + result
          }
        }, '')

        selectedRemarkItemsContent.push(
          <div
            key={'selectedRemarkItemsContent-' + index}
            className={remarkTextStyle}
            // style={{
            //   display: '-webkit-box',
            //   overflow: 'hidden',
            //   textOverflow: 'ellipsis',
            //   lineHeight: '16px',
            //   maxHeight: '16px',
            //   WebkitLineClamp: '1',
            //   WebkitBoxOrient: 'vertical',
            // }}
          >{remarksForItem}
          </div>)
      })
    }

    let remarkBtn
    if (hideRemarkMerchant.includes(_.get(merchant, 'id', ''))) {
      remarkBtn = <div />
    } else if (isCheckout) {
      const isSet = _.get(order, 'steps.length')
      remarkBtn = (
        isSet
          ? <div /> // > render an empty div for space-between with stepper.
          : (
            <div
              className={remarkButtonStyle}
              onClick={() => this.onRemarkBtnClick(order, orderIndex)}
            >
              {checkoutItemRemarkText}
            </div>
          )

      )
    } else if (isTakeawaySummary) {
      remarkBtn = <div /> // > in takeaway_summary page, replace remark button by using an empty div.
    }

    // > HISTORY!!! (Array)
    if (lang.isArray(order)) {
      const item = order.map((item, index) => {
        if (item.cancelled) {
          // Check if order is cancelled
          item.total = intl.formatMessage({ id: 'checkout.status.cancelled' })
        }
        item.remarks = item.remarks || []
        // perItemSelectedRemarkItems = selectedRemarkItems[item.dishId];
        selectedRemarkItemsContent = item.remarks.map((ele, index) => {
          const length = item.remarks.length
          if (length > 0 && index !== length - 1) {
            return ele + ', '
          } else {
            return ele
          }
        })

        return (
          <li key={index} className={itemOfDishStyle}>
            {isHistory && <div className={bgShapeHistoryStyle} />}
            <Flex>
              <Flex.Item>
                <div className={totalOfQtyStyle}>
                  {`${_totalChooseFrontText} ${item.quantity ? item.quantity : '1'} ${_totalChooseBackText} `}
                </div>
              </Flex.Item>
            </Flex>
            <Flex>
              <Flex.Item className={itemWrapStyle}>
                <div>
                  <div className={nameOfDishStyle}>
                    {item.dish}
                  </div>
                  <div>
                    {selectedRemarkItemsContent}
                  </div>
                </div>
                <div className={totalOfPriceStyle}>
                  <div className={!item.cancelled ? totalOfPricePrefixStyle : hiddenStyle}>
                    <FontAwesomeIcon icon='dollar-sign' />
                  </div>

                  {!item.priceUndetermined &&
                    <div className={totalOfPriceTextStyle}>
                      {item.total}
                    </div>}

                  {item.priceUndetermined &&
                    <div className={totalOfPriceTextStyle}>
                      {_undeterminedPrice}
                    </div>}
                </div>
              </Flex.Item>
            </Flex>
            {this.renderOptionWrap(item.options)}
          </li>
        )
      })

      return (
        <React.Fragment>
          {this.renderHistoryDateTitle(date, table, serial, status, takeawayStatus, code)}
          <ul>
            {item}
          </ul>
          {this.renderHistoryItemTotal(order, date, originalTotal, discount, discountTotal, surcharge, surchargeTotal, total, paymentKey)}
        </React.Fragment>
      )
    } else {
      // > CHECKOUT!!! (Object)
      if (!lang.isEmpty(order.options)) {
        itemOptionsTotalPrice = order.options.reduce((accumulator, itemOption) => {
          return accumulator + itemOption.reduce((accumulator, currentValue) => {
            if (typeof currentValue.quantity !== 'undefined') {
              return accumulator + currentValue.price * currentValue.quantity
            } else {
              return accumulator + currentValue.price
            }
          }, 0)
        }, 0)
      } else if (!lang.isEmpty(order.items)) {
        itemOptionsTotalPrice = order.items.reduce((accumulator, item) => {
          return accumulator + item.options.reduce((accumulator, itemOption) => {
            return accumulator + itemOption.reduce((accumulator, currentValue) => {
              if (typeof currentValue.quantity !== 'undefined') {
                return accumulator + currentValue.price * currentValue.quantity
              } else {
                return accumulator + currentValue.price
              }
            }, 0)
          }, 0)
        }, 0)
      }
      if (!isSwitchOnEditMode) {
        const result = helpers.calculate.calculateOrders([order], merchant)
        itemEdit = (
          <div className={totalOfPriceStyle}>
            <div className={totalOfPricePrefixStyle}>
              <FontAwesomeIcon icon='dollar-sign' />
            </div>
            {!order.priceUndetermined && <div className={totalOfPriceTextStyle}>{order.originalTotal || result.total}</div>}
            {order.priceUndetermined && <div className={totalOfPriceTextStyle}>{_undeterminedPrice}</div>}
          </div>
        )
      } else {
        if (merchant &&
          this.state.shouldShowPerItemRemarkDialog &&
          this.state.shouldShowRemarkDialog === orderIndex &&
          this.state.shouldShowRemarkDialogIndex !== -1) {
          const item = this.state.remarkItem
          const subItemIndex = _.findIndex(order.items, { dishId: item.dishId })
          const selectedRemarks = this.state.isSetItem ? order.items[subItemIndex].remarks : selectedRemarkItems[orderIndex]

          perItemRemarkDialog = (
            <DialogComponent
              dialogType='remark'
              title={intl.formatMessage({ id: 'checkout.item.remark' })}
              message=''
              onCancel={() => {
                this.setState({
                  remarkItem: null,
                  isSetItem: false,
                  shouldShowRemarkDialog: false,
                  shouldShowPerItemRemarkDialog: false,
                })
              }}
              orderIdx={orderIndex}
              dishId={order.dishId}
              subItemIndex={subItemIndex}
              isSetItem={this.state.isSetItem}
              merchantId={merchant.id}
              selectedRemarkItems={selectedRemarks}
              selectedItemIdex={this.state.shouldShowRemarkDialogIndex}
              onRemarkItemSelected={(remark, index) => {
                const dict = JSON.parse(JSON.stringify(selectedRemarkItems))
                const selectedRemarkIndex = this.state.shouldShowRemarkDialogIndex
                let tmp = dict[orderIndex][selectedRemarkIndex]
                if (!tmp) {
                  tmp = []
                  tmp.push(remark)
                } else {
                  if (tmp.indexOf(remark) === -1) {
                    tmp.push(remark)
                  }
                }

                if (this.state.isSetItem) {
                  const item = this.state.remarkItem
                  const itemIndex = _.findIndex(order.items, { dishId: item.dishId })

                  updatePerItemRemark({
                    remarks: tmp,
                    orderIndex: orderIndex,
                    isSet: true,
                    itemIndex: itemIndex,
                  })
                } else {
                  // 有 steps 是單點，remark 直接設定到 order
                  updatePerItemRemark({
                    remarks: tmp,
                    selectedRemarkIndex: selectedRemarkIndex,
                    orderIndex: orderIndex,
                    isSet: false,
                  })
                }
              }}
            />
          )
        }
        // > still editing (stepper)
        itemEdit = (
          <div
            className={totalOfPriceStyle}
            style={{ width: '90px' }}
          >
            {order.priceUndetermined
              ? <div>{_undeterminedPrice}</div>
              : (
                <div>
                  {
                    (_.get(merchant, 'setting.hotelMode') && order.total + itemOptionsTotalPrice === 0)
                      ? null
                      : (
                        <div>
                          <div className={totalOfPricePrefixStyle}>
                            <FontAwesomeIcon icon='dollar-sign' />
                          </div>
                          {order.total + itemOptionsTotalPrice}
                        </div>
                      )
                  }
                </div>
              )}
            <StepperContainer
              disableInc={order.steps}
              menuId={order.menuId}
              item={order}
              itemId={order.dishId}
              itemName={order.dish}
              itemPrice={order.price}
              itemDiscount={order.discount}
              itemGroups={order.itemGroups}
              category={order.category}
              setStep={order.setStep}
            />
          </div>
        )
      }

      return (
        <div className='sub-list'>
          <div className={totalOfQtyStyle}>
            {`${_totalChooseFrontText} ${order.quantity ? order.quantity : '1'} ${_totalChooseBackText}`}
          </div>
          <div className={nameOfDishStyle}>
            {(order.dish) ? order.dish : order.name}
          </div>
          {perItemRemarkDialog}
          <div className={remarkBtnAndItemEditContainerStyle}>
            {remarkBtn}
            {itemEdit}
          </div>
          {// > general item's remark
            selectedRemarkItemsContent
          }
          {order.items ? this.renderSets(order.steps, order.items, orderIndex) : this.renderOptionWrap(order.options)}
        </div>
      )
    };
  }

  renderOptionWrap = (options) => {
    const {
      intl,
      classes,
    } = this.props

    const _especialTitleText = intl.formatMessage({ id: 'checkout.especial_title' })

    const especialWrapStyle = cx(classes['especial-wrap'])
    const especialTitleStyle = cx(classes['especial-title'])
    const especialOfOptionStyle = cx(classes['especial-option'])
    const hasOptions = collection.some(options, (option) => !lang.isEmpty(option))

    if (hasOptions) {
      return (
        <Flex>
          <Flex.Item>
            <div className={especialWrapStyle}>
              <div className={especialTitleStyle}>
                {_especialTitleText}
              </div>
              <div className={especialOfOptionStyle}>
                <ul>
                  {this.renderOptions(options)}
                </ul>
              </div>
            </div>
          </Flex.Item>
        </Flex>
      )
    }
  }

  renderHistoryDateTitle = (date, table, serial, status, takeawayStatus, code) => {
    const {
      intl,
      classes,
    } = this.props

    const _todayText = intl.formatMessage({ id: 'checkout.today' })
    const _serialText = intl.formatMessage({ id: 'checkout.serial' })

    let _tableNoText
    if (!table) {
      _tableNoText = intl.formatMessage({ id: 'footer.takeaway_no' })
    } else {
      _tableNoText = table
        ? intl.formatMessage({ id: 'footer.table_no' }, { value: table })
        : ''
    }

    let _statusColor = '#f19736'
    let _codeText = ''
    if (takeawayStatus === 'ready' || takeawayStatus === 'completed') {
      status = takeawayStatus
      _codeText = intl.formatMessage({ id: 'checkout.code' }) + ': ' + code
      if (takeawayStatus !== 'completed') {
        _statusColor = '#a91d1d'
      }
    }

    const _time = helpers.date.getTimeFormat(date)
    const _isToday = helpers.date.isToday(date)
    const isTodayLabel = _isToday ? _todayText : helpers.date.getDateFormat(date)
    const _serial = serial
    const _status = intl.formatMessage({ id: 'checkout.status.' + status })

    const historyDateWrapStyle = cx(classes['history-date-wrap'])
    const historyDateStyle = cx(classes['history-date'], _isToday ? classes['today-background'] : classes['not-today-background'])
    const historyTableWrapStyle = cx(classes['history-table-wrap'])
    const historySerialWrapStyle = cx(classes['history-serial-wrap'])
    const historyStatusWrapStyle = cx(classes['history-status-wrap'])
    const historySerialLableStyle = cx(classes['history-serial-label'])
    const historySerialContentStyle = cx(classes['history-serial-content'])
    // const historyInfoWrapStyle = cx(classes['history-info-wrap'])
    // const historyStatusLableStyle = cx(classes['history-status-label'])

    return (
      <div>
        <div>
          <Flex className={historyDateWrapStyle}>
            <Flex.Item>
              <div className={historyDateStyle}>
                <span>
                  {isTodayLabel}
                </span>
                <span>
                  {_time}
                </span>
              </div>
              <div className={historyStatusWrapStyle}>
                <span>
                  {_codeText}
                </span>
                <span>
                  <Badge
                    text={_status}
                    style={{
                      marginLeft: 12,
                      padding: '0 3px',
                      backgroundColor: '#fff',
                      borderRadius: 2,
                      color: _statusColor,
                      border: '1px solid ' + _statusColor,
                    }}
                  />
                </span>
              </div>
            </Flex.Item>
          </Flex>
        </div>
        <div>
          <Flex>
            <Flex.Item>
              <div className={historySerialWrapStyle}>
                <span className={historySerialLableStyle}>
                  {_serialText}:
                </span>
                <span className={historySerialContentStyle}>
                  {_serial}
                </span>
              </div>
            </Flex.Item>
            <Flex.Item>
              <div className={historyTableWrapStyle}>
                <span>
                  {_tableNoText}
                </span>
              </div>
            </Flex.Item>
          </Flex>
        </div>
      </div>
    )
  }

  renderHistoryItemTotal = (items, date, originalTotal, discount, discountTotal, surcharge, surchargeTotal, total, paymentKey) => {
    const {
      intl,
      classes,
      basket,
      merchant,
    } = this.props

    const m = new Merchant(merchant)

    const _totalOfFrontText = intl.formatMessage({ id: 'checkout.total_of_front' })
    const _totalOfBackText = _.get(merchant, 'setting.hotelMode')
      ? intl.formatMessage({ id: 'checkout.total_of_back2' })
      : intl.formatMessage({ id: 'checkout.total_of_back' })

    const _originalTotal = originalTotal
    const _discount = discount
    const _discountTotal = discountTotal
    const _surcharge = surcharge
    const _surchargeTotal = surchargeTotal
    const _total = total
    const _customizedPayment = m.findPaymentName(paymentKey) // return payment.name || ''
    // if _customizedPayment === '' means it is default payment like 'cash' or 'visa'...etc.
    const _payment = _customizedPayment || paymentKey ? intl.formatMessage({ id: 'checkout.method.' + paymentKey }) : ''

    let priceTotalElement = ''
    const historyItemTotalWrapStyle = cx(classes['history-item-total-wrap'])
    const historyItemTotalStyle = cx(classes['history-item-total'])
    const historyItemPriceStyle = cx(classes['history-item-price'])
    const historyItemOriginalPriceStyle = cx(classes['history-item-original-price'])
    const historyItemOriginalPricePrefixStyle = cx(classes['history-item-original-price-prefix'])
    const historyItemOriginalPriceTextStyle = cx(classes['history-item-original-price-text'])
    const historyItemDiscountPriceStyle = cx(classes['history-item-discount-price'])
    const historyItemDiscountPricePrefixStyle = cx(classes['history-item-discount-price-prefix'])
    const historyItemDiscountPriceTextStyle = cx(classes['history-item-discount-price-text'])
    const historyPriceTotalElementPrefix = cx(classes['history-price-total-element-prefix'])
    const historyPriceTotalElementText = cx(classes['history-price-total-element-text'])
    // const historyItemTimeStyle = cx(classes['history-item-time'])
    // const historyItemDateTimeStyle = cx(classes['history-item-date-time'])
    // const historyItemDateTimeTitleStyle = cx(classes['history-item-date-time-title'])

    const detailOfDishes = items.reduce((accumulator, item) => {
      return {
        total: accumulator.total + item.total,
        quantity: accumulator.quantity + item.quantity,
      }
    }, {
      total: 0,
      quantity: 0,
    })

    // > IS FILTERED BY ME
    if (!basket.isFilteredByMe) {
      if (_originalTotal > detailOfDishes.total) {
        priceTotalElement = (
          <React.Fragment>
            <div className={historyItemOriginalPriceStyle}>
              <div className={historyItemOriginalPricePrefixStyle}>
                <FontAwesomeIcon icon='dollar-sign' />
              </div>
              <div className={historyItemOriginalPriceTextStyle}>
                {_total}
              </div>
            </div>
            <div className={historyItemDiscountPriceStyle}>
              <div className={historyItemDiscountPricePrefixStyle}>
                <FontAwesomeIcon icon='dollar-sign' />
              </div>
              <div className={historyItemDiscountPriceTextStyle}>
                {detailOfDishes.total}
              </div>
            </div>
          </React.Fragment>
        )
      } else {
        priceTotalElement = (
          <Flex>
            <Flex.Item>
              <span className={historyItemTotalStyle}>{_payment}</span>
            </Flex.Item>
            <div className={historyPriceTotalElementPrefix}>
              <FontAwesomeIcon icon='dollar-sign' />
            </div>
            <div className={historyPriceTotalElementText}>
              {_total}
            </div>
          </Flex>
        )
      }
    }

    return (
      <Flex
        className={historyItemTotalWrapStyle}
        align='start'
      >
        <Flex.Item>
          <div className={historyItemTotalStyle}>
            <div>
              {this.renderOtherPriceDetail(_surcharge, _surchargeTotal, _discount, _discountTotal)}
            </div>
            <div />

            <span className={historyItemTotalStyle}>
              {`${_totalOfFrontText} ${detailOfDishes.quantity} ${_totalOfBackText}`}
            </span>
            <div className={historyItemPriceStyle}>
              {priceTotalElement}
            </div>
          </div>
        </Flex.Item>
      </Flex>
    )
  }

  renderOtherPriceDetail = (surcharge, surchargeTotal, discount, discountTotal) => {
    const {
      intl,
      classes,
      basket,
    } = this.props

    const _surcharge = surcharge
    const _surchargeTotal = surchargeTotal
    const _discount = discount
    const _discountTotal = discountTotal

    const _surchargeText = intl.formatMessage({ id: 'checkout.surcharge' })
    const _discountText = intl.formatMessage({ id: 'checkout.discount' })

    const otherPriceChargeListStyle = cx(classes['other-price-charge-list'])
    const otherPriceChargeTextStyle = cx(classes['other-price-charge-text'])
    const otherPriceChargeTextLabelStyle = cx(classes['other-price-charge-text-label'])
    const otherPriceChargeSpanLabelStyle = cx(classes['other-price-charge-span-label'])

    return (
      <div>
        {
          !basket.isFilteredByMe && _surchargeTotal > 0 && (
            <div className={otherPriceChargeListStyle}>
              <span>
                <span className={otherPriceChargeTextLabelStyle}>
                  {_surchargeText}({_surcharge.percent}%):
                </span>
              </span>
              <span className={otherPriceChargeTextStyle}>
                <FontAwesomeIcon icon='dollar-sign' />
                {_surchargeTotal}
              </span>
            </div>
          )
        }
        {
          !basket.isFilteredByMe && _discountTotal > 0 && (
            <div className={otherPriceChargeListStyle}>
              <span>
                <span className={otherPriceChargeTextLabelStyle}>
                  {_discountText}({_discount.percent}%):
                </span>
              </span>
              <span className={otherPriceChargeTextStyle}>
                <span className={otherPriceChargeSpanLabelStyle}>
                  -
                </span><FontAwesomeIcon icon='dollar-sign' />{_discountTotal}
              </span>
            </div>
          )
        }
      </div>
    )
  }

  renderSets = (steps, items, orderIndex) => {
    const { classes } = this.props

    const especialWrapStyle = cx(classes['especial-wrap'])
    const especialTitleStyle = cx(classes['especial-title'])
    const especialOfOptionStyle = cx(classes['especial-option'])

    return steps.map((step, stepIndex) => {
      const stepItems = items.filter((item) => item.setStep.key === step.key)
      if (stepItems.length === 0) return null
      return (
        <Flex key={stepIndex}>
          <Flex.Item>
            <div className={especialWrapStyle}>
              <div className={especialTitleStyle}>
                {step.name}
              </div>
              <div className={especialOfOptionStyle}>
                <ul>
                  {this.renderSetItems(stepItems, orderIndex)}
                </ul>
              </div>
            </div>
          </Flex.Item>
        </Flex>
      )
    })
  }

  renderOptionGroups = (items) => {
    return items.map((option, optionIndex) => {
      const quantity = option.quantity && option.quantity > 1 ? `(${option.quantity})` : ''
      return (
        <React.Fragment key={optionIndex}>
          <div>
            {option.name}
            {quantity}
          </div>
        </React.Fragment>
      )
    })
  }

  renderOptions = (items) => {
    return items.map((item, itemIndex) => {
      if (!lang.isEmpty(item)) {
        return (
          <React.Fragment key={itemIndex}>
            <li>
              {this.renderOptionGroups(item)}
            </li>
          </React.Fragment>
        )
      } else return null
    })
  }

  renderSetItems = (stepItems, orderIndex) => {
    const {
      intl,
      classes,
      merchant,
    } = this.props

    const checkoutItemRemarkText = intl.formatMessage({ id: 'checkout.item.remark' })
    const hideRemarkMerchant = [
      '48f66a19-5a37-4be1-b214-dfaf4467bb9b',
      '5fa30907-a524-446e-9133-9058b1d05db3',
      'fa817536-812e-4bd1-99f1-caf9b621694e',
      'a5aaadea-e0f0-427c-86d3-86bd0d09c090',
      '51f6c478-7746-4373-96f9-d2eae91b97b8',
      'dbcebe9a-8ed9-4626-80bf-6d2613d1b1bb',
    ]

    const stepItemContainerStyle = cx(classes['step-item-container'])
    const stepItemTopStyle = cx(classes['step-item-top'])
    const remarkButtonStyle = cx(classes['remark-button'])
    const remarkTextStyle = cx(classes['remark-text'])

    return stepItems.map((item, itemIndex) => {
      const isNotRequired = item.dishId.startsWith('0-')
      return (
        <li key={itemIndex} className={stepItemContainerStyle}>
          {/** Top: dish and remark button area */}
          <div className={stepItemTopStyle}>
            <div>
              {item.dish} x {item.quantity}
              {
                !lang.isEmpty(item.itemGroups) &&
                this.renderSetItemOptions(item.options.filter(o => !_.isEmpty(o)))
              }
            </div>

            {/** Remark button */}
            {/** hide remark button when item is notRequired */}
            {(!isNotRequired && !hideRemarkMerchant.includes(_.get(merchant, 'id', ''))) && (
              <div
                className={remarkButtonStyle}
                onClick={() => {
                // item is step items 中的一個
                  this.onRemarkBtnClick(item, orderIndex, true)
                }}
              >{checkoutItemRemarkText}
              </div>
            )}

          </div>

          {/** Bottom: reamrk text area */}
          {// > render remark only when remark exist. (remarks[0] is not empty)
            item.remarks[0].length > 0 && (
              <div className={remarkTextStyle}>
                {item.remarks[0].join(', ')}
              </div>
            )
          }

        </li>
      )
    })
  }

  renderSetItemOptions = (options) => {
    const { classes } = this.props

    const setItemOptions = cx(classes['set-item-options'])

    const _optionItems = options.map((optionItems, optionsItemsIndex) => {
      const _optionItem = optionItems.map((optionItem, optionItemIndex) => {
        return (
          <React.Fragment key={optionItemIndex}>
            <li>{optionItem.name}</li>
          </React.Fragment>
        )
      })
      return (
        <ul className={setItemOptions} key={optionsItemsIndex}>
          {_optionItem}
        </ul>
      )
    })
    return (
      <React.Fragment>
        {_optionItems}
      </React.Fragment>
    )
  }

  setRemark = (event) => {
    const { setBasketRemark } = this.props
    setBasketRemark(event.target.value)
  }

  render () {
    const {
      intl,
      history,
      list,
      paymentMethod,
    } = this.props
    const path = history.location.pathname
    const isTakeawayWaiting = path === '/basket/takeaway_waiting'

    const _chooseDeleteDishOptionText = intl.formatMessage({ id: 'dialog.choose_delete_dish_option' })
    return (
      <div style={{ position: 'relative' }}>
        {this.renderCheckoutOrder(list)}
        {isTakeawayWaiting && paymentMethod && paymentMethod}
        {this.state.isOpenModal &&
          <DialogComponent
            isOpen
            triggerItemOptionsOverlayEvent={() => this.setState({ isOpenModal: false })}
            dialogType='content'
            title={_chooseDeleteDishOptionText}
            contentType='options'
            optionContent={this.state.shouldShowRemarkOptions}
            remarkContent={this.state.shouldShowRemarkRemarks}
            confirmButtonAction={(index) => {
              this.setState({
                shouldShowPerItemRemarkDialog: true,
                shouldShowRemarkDialogIndex: index,
                isOpenModal: false,
              })
            }}
          />}
      </div>
    )
  }
}

export default withRouter(injectIntl(injectSheet(styles)(CheckoutItemComponent)))



// WEBPACK FOOTER //
// ./src/components/CheckoutItem.js